import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyGetVisitasQuery } from '../../../../services/visitasApi';
import dayjs, { Dayjs } from 'dayjs';

interface ViewExecutionFormData {
    esFallida: boolean;
    totalPersonal: number | null;
    administrativos: number | null;
    personalProduccion: number | null;
    seguridadHigiene: boolean | null;
    profesional: string;
    matricula: string;
    idTipoVisita: number | null;
    idSubTipoVisita: number | null;
    observacion: string;
    firmaPreventor: string;
    firmaResponsable: string;
    fechaVisita: Dayjs | null;
    fechaLimite: Dayjs | null;
    nombreTipoVisita: string;
    idPresentacion: number | null;
    idVisita: number | null;
    id: number | null;
}

export const useViewExecutionVisit = () => {
    const { idVisita } = useParams<{ idVisita: string }>();
    const [fetchVisitaById, { data, isFetching }] = useLazyGetVisitasQuery();
    const [formData, setFormData] = useState<ViewExecutionFormData | null>(null);

    useEffect(() => {
        if (idVisita) {
            fetchVisitaById({ idVisita: Number(idVisita), skip: 0, take: 10 });
        }
    }, [idVisita]);

    useEffect(() => {
        if (data?.data?.data?.[0]) {
            const visita = data.data.data[0];

            setFormData({
                esFallida: visita.idEstado === 3,
                totalPersonal: visita.totalPersonal ?? null,
                administrativos: visita.administrativos ?? null,
                personalProduccion: visita.personalProduccion ?? null,
                seguridadHigiene: visita?.seguridadHigiene ?? null,
                profesional: visita?.profesional || '',
                matricula: visita?.matricula || '',
                idTipoVisita: visita.idTipoVisita ?? null,
                idSubTipoVisita: visita.idSubTipoVisita ?? null,
                observacion: visita.observacion || '',
                firmaPreventor: visita.firmaPreventor || '',
                firmaResponsable: visita.firmaResponsable || '',
                fechaVisita: visita.fechaVisita ? dayjs(visita.fechaVisita) : null,
                fechaLimite: visita.fechaLimite ? dayjs(visita.fechaLimite) : null,
                nombreTipoVisita: visita.nombreTipoVisita || '',
                idPresentacion: visita.idPresentacion,
                idVisita: visita.idVisita,
                id: visita.id
            });
        }
    }, [data]);

    return {
        formData,
        isLoading: isFetching
    };
};
